import { createSelector } from 'reselect';

import { AppState } from '../../store/store';
import { NewsState } from './news-reducer';
import { localesSelector } from './configuration-selectors';
import { mapNewsPost } from '../models/mapper/news-mapper';

const newsState = (state: AppState): NewsState => state.news;

export const newsSelector = createSelector(localesSelector, newsState, (locales, state) => ({
    news: state.news.items.map(news => mapNewsPost(locales, news)),
    total: state.news.total,
    page: state.news.page,
    pages: state.news.pages,
}));

export const newsSliderItemSelector = createSelector(localesSelector, newsState, (locales, state) => ({
    news: state.newsSliderItems.items.map(news => mapNewsPost(locales, news)),
    total: state.newsSliderItems.total,
    page: state.newsSliderItems.page,
    pages: state.newsSliderItems.pages,
}));

export const newsDetailSelector = createSelector(localesSelector, newsState, (locales, state) => {
    if (!state.newsDetail) {
        return null;
    }
    return mapNewsPost(locales, state.newsDetail);
});
